import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createCollaboratorActions } from './actions';
import { CollaboratorActions, CollaboratorState } from './types';

export const useCollaboratorStore = create<CollaboratorState & CollaboratorActions>()(
    immer((set, get, store) => ({
        collaborators: {},
        requestStatus: {},
        ...createCollaboratorActions(set, get, store),
    })),
);
